import React, { Fragment } from 'react'
import { useTranslations } from 'next-intl'
import { DotsThreeVerticalIcon } from '@phosphor-icons/react/dist/ssr/DotsThreeVertical'
import { DropdownMenu } from '@skop-app/lib-front'
import { ReviewStatus } from '@skop-app/lib-types'

type MessageMenuProps = {
  t: ReturnType<typeof useTranslations>
  isFirst: boolean
  isOwner?: boolean
  status?: ReviewStatus
  canReviewDecision: boolean
  canRejectDecision?: boolean
  reviewDecisionReasonLabel?: string
  rejectLabel?: string
  handleReviewStatus: (status: ReviewStatus) => void
}

export const MessageMenu = ({
  t,
  isFirst,
  isOwner: _isOwner,
  status,
  canReviewDecision,
  canRejectDecision = true,
  reviewDecisionReasonLabel,
  rejectLabel,
  handleReviewStatus,
}: MessageMenuProps) => {
  const withReason = (label: string) =>
    !canReviewDecision && reviewDecisionReasonLabel
      ? `${label} · ${reviewDecisionReasonLabel}`
      : label

  const menu = [
    ...(isFirst && status === ReviewStatus.PENDING
      ? [
          {
            label: withReason(t('Common.accept')),
            onClick: () => handleReviewStatus(ReviewStatus.ACCEPTED),
            disabled: !canReviewDecision,
          },
          ...(canRejectDecision
            ? [
                {
                  label: withReason(rejectLabel ?? t('Common.reject')),
                  onClick: () => handleReviewStatus(ReviewStatus.REJECTED),
                  disabled: !canReviewDecision,
                },
              ]
            : []),
        ]
      : []),
    // ...(isOwner
    //   ? [
    //       {
    //         label: t('Common.edit'),
    //         onClick: () => null,
    //         disabled: true,
    //       },
    //       {
    //         label: t('Common.delete'),
    //         onClick: () => null,
    //         disabled: true,
    //       },
    //     ]
    //   : []),
  ]

  if (menu.length === 0) return null

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="inline-flex size-8 items-center justify-center rounded-full transition hover:bg-gray-200">
          <DotsThreeVerticalIcon className="size-5 text-slate-300" />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="end">
          <DropdownMenu.Group>
            {menu.map((item, index) => (
              <Fragment key={item.label}>
                <DropdownMenu.Item
                  onClick={item.onClick}
                  className="!py-1"
                  disabled={item.disabled}
                >
                  {item.label}
                </DropdownMenu.Item>
                {index < menu.length - 1 && (
                  <DropdownMenu.Separator className="bg-gray-200" />
                )}
              </Fragment>
            ))}
          </DropdownMenu.Group>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
